<div>
  <hr role="separator" [attr.aria-orientation]="orientation">
  <span aria-hidden="true">
    <ng-content></ng-content>
  </span>
  <hr role="separator" [attr.aria-orientation]="orientation">
</div>
